export default {
  pt: {
    title: "Pedimos desculpas!",
    errorMessage: "Houve um erro durante a contratação do seguro.",
    contactMessage: "Entre em contato com a nossa equipe de atendimento através do WhatsApp clicando no botão abaixo.",
    supportButton: "Atendimento",
  },

  en: {
    title: "We apologize!",
    errorMessage: "There was an error during insurance contracting.",
    contactMessage: "Contact our support team via WhatsApp by clicking the button below.",
    supportButton: "Support",
  },
}; 